import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { GlobalService } from '../global-service.service';

@Component({
    selector: 'app-transportversicherung',
    templateUrl: './transportversicherung.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})

export class TransportversicherungComponent implements OnInit {

  tv= {"DatAb": "2023-05-01"};
   
  constructor(private http:HttpClient, public globserv: GlobalService,) 
  {}

  ngOnInit(): void {
  }
  
 
  
  
  
  async getListe()
  {
		var data= {}
		
				
		try {
      
      	this.downloadFile(await this.http.post("/api/v1/getMeldelisteTransport", data, {responseType: 'blob' }).toPromise(), "Transportliste_"+this.globserv.getTimeStampString()+".xlsx");
      	
  		} catch (e) {
  		
      	console.log(e);
  		}
  }
  
  
  	downloadFile(data, fileName) 
	{
		console.log(JSON.stringify(data));
    
			//.log();
       const url = window.URL.createObjectURL(data);
       var anchorElement = document.createElement("a");
        
       anchorElement.href = url;
  		 anchorElement.download = fileName;
       anchorElement.click();

  		window.URL.revokeObjectURL(url);
        window.open(url);
  	} 
  
  
 
}
